import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import AppLayout from "@/shared/components/layout/AppLayout";

const AdminDashboard = lazy(() => import("@/features/admin/pages/AdminDashboard"));
const AdminRestaurants = lazy(() => import("@/features/admin/pages/AdminRestaurants"));
const AdminOwners = lazy(() => import("@/features/admin/pages/AdminOwners"));
const ConnectScopeMigration = lazy(() =>
  import("@/features/admin/pages/ConnectScopeMigration")
);

/**
 * Admin Routes Configuration
 *
 * These routes require ADMIN role authentication.
 * Used for platform administration: restaurant approval, owner management, stats.
 */
export const adminRoutes = (
    <>
        <Route
            path="/admin"
            element={
                <ProtectedRoute>
                    <AppLayout>
                        <AdminDashboard />
                    </AppLayout>
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/restaurants"
            element={
                <ProtectedRoute>
                    <AppLayout>
                        <AdminRestaurants />
                    </AppLayout>
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/owners"
            element={
                <ProtectedRoute>
                    <AppLayout>
                        <AdminOwners />
                    </AppLayout>
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/migrations/connect-user-scope"
            element={
                <ProtectedRoute>
                    <AppLayout>
                        <ConnectScopeMigration />
                    </AppLayout>
                </ProtectedRoute>
            }
        />
    </>
);
